import { PatientIntakeConsultationSummaryV2 } from "~/providers/utils/types/patientIntakePreviewTypes";
import {
  PatientScreeningConsultationSummaryV2,
  SUMMARY_TYPE,
} from "~/providers/utils/types/patientPreviewTypes";
import { isFeedbackLiked } from "./isFeedbackLiked";

interface GetConsultationSummaryDataProps {
  screeningSummary: PatientScreeningConsultationSummaryV2;
  intakeSummary?: PatientIntakeConsultationSummaryV2;
}

export const getConsultationSummaryV2Data = ({
  screeningSummary,
  intakeSummary,
}: GetConsultationSummaryDataProps) => {
  const {
    id: screeningSummaryId,
    feedbacks: screeningFeedbacks,
    data: {
      case_summary: caseSummaryScreening,
      potential_areas_of_concern: potentialAreasOfConcern,
      medications,
      scores,
    },
  } = screeningSummary;

  const {
    id: intakeSummaryId,
    feedbacks: intakeFeedbacks,
    data: intakeSummaryData,
  } = { ...intakeSummary };

  const {
    case_summary: caseSummaryIntake,
    functional_domains: functionalDomains,
    health_history: healthHistory,
    personal_life_history: personalLifeHistory,
    treatment_recommendations: treatmentRecommendations,
    allergies,
  } = { ...intakeSummaryData };

  const isSummaryLiked = intakeSummaryId
    ? isFeedbackLiked(SUMMARY_TYPE.intake, intakeFeedbacks)
    : isFeedbackLiked(SUMMARY_TYPE.screening, screeningFeedbacks);

  const isTreatmentRecommendationsLiked = isFeedbackLiked(
    SUMMARY_TYPE.treatment_recommendations,
    intakeFeedbacks,
  );

  const caseSummary = caseSummaryIntake ?? caseSummaryScreening;

  return {
    caseSummaryScreening,
    potentialAreasOfConcern,
    screeningSummaryId,
    intakeSummaryId,
    isSummaryLiked,
    isTreatmentRecommendationsLiked,
    personalLifeHistory,
    healthHistory,
    caseSummary,
    medications,
    scores,
    functionalDomains,
    treatmentRecommendations,
    allergies,
  };
};
